import { Grid, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { SeatAreaContext } from '../../../../../contexts/SeatAreaContext';
import { useSeatBet } from '../../../../../hooks/useSeatBet';

export const TotalBetAmount = () => {
    const [display, setDisplay] = useState(0);
    const { inSeat, room } = useContext(SeatAreaContext);
    const {
        split1Amount,
        split2Amount,
        pairAmount,
        isBehind,
        behindPairAmount,
        behindSplit1Amount,
        behindSplit2Amount,
    } = useSeatBet(inSeat);
    useEffect(() => {
        const sum =
            isBehind || isBehind === 0
                ? behindPairAmount + behindSplit1Amount + behindSplit2Amount
                : split1Amount + split2Amount + pairAmount;
        setDisplay(sum / 100);
    }, [
        room,
        inSeat,
        split1Amount,
        split2Amount,
        pairAmount,
        isBehind,
        behindPairAmount,
        behindSplit1Amount,
        behindSplit2Amount,
    ]);
    return (
        <Grid
            container
            spacing={1}
            className="blackjack-total-bet-amount"
            sx={{ zIndex: 0, marginTop: 'auto' }}
        >
            <Grid item>
                <TotalBetAmountIcon />
            </Grid>
            <Grid item>
                <Typography fontSize={'1.3rem'}>
                    {display.toLocaleString('en-US', {
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2,
                    })}
                </Typography>
            </Grid>
        </Grid>
    );
};

const TotalBetAmountIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
        style={{ position: 'relative', top: '0.5rem' }}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.4944 6.18049C14.2289 6.19371 12.9682 6.02081 11.7508 5.66707C11.0054 4.8727 10.1 4.25391 9.09752 3.85367C9.0286 3.69166 8.99276 3.51695 8.99219 3.34025C8.99219 1.77123 11.9002 0.5 15.4944 0.5C19.0886 0.5 21.9976 1.77123 21.9976 3.34025C21.9976 4.90926 19.0856 6.18049 15.4944 6.18049ZM15.4961 7.63766C17.3919 7.71737 19.2736 7.27218 20.943 6.34897C21.2048 6.18084 21.4399 5.97272 21.6402 5.73184C21.8636 5.47289 21.9911 5.14178 22.0003 4.79639V6.66729C22.0003 8.23631 19.0902 9.50754 15.4981 9.50754C14.8898 9.5082 14.2821 9.47047 13.6784 9.39459C13.5394 8.70601 13.3072 8.04068 12.9883 7.41792C13.8163 7.56621 14.6555 7.63974 15.4961 7.63766ZM13.623 12.7082C14.2439 12.7888 14.8691 12.8289 15.4949 12.8283C19.087 12.8283 21.9971 11.556 21.9971 9.98804V8.11816C21.9881 8.46359 21.8606 8.79476 21.637 9.05362C21.4375 9.29391 21.2034 9.50166 20.9428 9.66972C19.2731 10.5929 17.391 11.0381 15.4949 10.9584C14.9375 10.9589 14.3806 10.9274 13.8267 10.8639V10.9358C13.8273 11.5327 13.7589 12.1277 13.623 12.7082ZM21.998 13.3057C21.998 14.8747 19.087 16.1459 15.4958 16.1459C14.3686 16.1535 13.2449 16.0179 12.1504 15.7424C12.5552 15.2374 12.8947 14.681 13.1605 14.0871C13.9327 14.2146 14.7137 14.2778 15.4958 14.276C17.3916 14.3556 19.2733 13.9104 20.9427 12.9874C21.2038 12.8195 21.4382 12.6117 21.6379 12.3712C21.8616 12.1124 21.9891 11.7812 21.998 11.4358V13.3057ZM7.94732 4.55899C11.3863 5.42586 13.4877 8.98232 12.6409 12.5026C11.7945 16.0229 8.32076 18.1743 4.8818 17.3083C1.44278 16.4414 -0.658891 12.8852 0.187205 9.36461C0.593652 7.67391 1.6396 6.21775 3.09492 5.31651C4.55025 4.41527 6.29572 4.14278 7.94732 4.55899ZM2.21939 12.1339C2.53037 13.2726 3.27055 14.2382 4.27708 14.8182H4.27608C5.28237 15.3985 6.47265 15.5458 7.58503 15.2276C8.69741 14.9095 9.64075 14.152 10.2075 13.1219C10.7744 12.0918 10.9183 10.8733 10.6075 9.73466C10.2967 8.59597 9.55672 7.63032 8.55036 7.05015C7.54407 6.46987 6.35379 6.3226 5.24141 6.64073C4.12903 6.95886 3.18569 7.71634 2.61893 8.7465C2.05214 9.77671 1.90842 10.9952 2.21939 12.1339ZM4.72596 4.92461L5.10012 6.34576C4.41351 6.57804 3.78442 6.96029 3.25639 7.46605L2.24023 6.42688C2.94627 5.73922 3.79599 5.22513 4.72496 4.92358L4.72596 4.92461ZM8.11769 16.9374L8.11804 16.9387L8.11704 16.9376L8.11769 16.9374ZM8.11769 16.9374L7.7168 15.538C8.39856 15.3099 9.02361 14.9325 9.54849 14.4321L10.5767 15.4425C9.87841 16.1253 9.03752 16.6365 8.11769 16.9374ZM12.3072 12.3794L10.9199 11.9974C11.084 11.2765 11.0929 10.5278 10.946 9.80303L12.3343 9.4231C12.5445 10.3972 12.5349 11.4076 12.3062 12.3773L12.3072 12.3794ZM1.87938 9.89961L0.510124 9.48887L0.509121 9.48682C0.279535 10.4511 0.268213 11.4562 0.476018 12.4256L1.86032 12.0765C1.71247 11.358 1.71897 10.6153 1.87938 9.89961ZM2.23928 15.4364L2.23982 15.4358C2.94604 16.1234 3.79591 16.6373 4.72501 16.9387L5.09917 15.5175C4.4125 15.2854 3.78337 14.9031 3.25544 14.3972L2.23982 15.4358L2.23828 15.4343L2.23928 15.4364ZM9.55435 7.43304L10.5825 6.42262L10.5765 6.42057C9.88003 5.73889 9.0414 5.22803 8.1239 4.92651L7.72266 6.32713C8.40445 6.55519 9.02951 6.93258 9.55435 7.43304ZM8.69203 13.2124C9.95061 11.9539 9.95061 9.91332 8.69203 8.65474C7.43346 7.39616 5.3929 7.39616 4.13432 8.65474C2.87575 9.91332 2.87575 11.9539 4.13432 13.2124C5.3929 14.471 7.43346 14.471 8.69203 13.2124Z"
            fill="#F5DFB6"
        />
    </svg>
);
